__turbopack_context__.v({
  "card-back": "FlipCard-module-scss-module__vhFBhW__card-back",
  "card-button": "FlipCard-module-scss-module__vhFBhW__card-button",
  "card-front": "FlipCard-module-scss-module__vhFBhW__card-front",
  "flip-inner": "FlipCard-module-scss-module__vhFBhW__flip-inner",
  "flip-outer": "FlipCard-module-scss-module__vhFBhW__flip-outer",
  "flipped-card": "FlipCard-module-scss-module__vhFBhW__flipped-card",
});
